// extracted by mini-css-extract-plugin
module.exports = {"root":"CheckBoxes_root__3Wt4i","noPad":"CheckBoxes_noPad__3-AWA","p":"CheckBoxes_p__18jIY","warn":"CheckBoxes_warn__x1Jl4"};